<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      allow-clear
      option-filter-prop="title"
      show-search
      :virtual="false"
      @change="onChange"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :title="item.bizNo"
        :value="item.id"
      >
        {{ item.bizNo }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, onActivated, onMounted, PropType, ref } from "vue";
import { ReceiveService } from "@/views/purchase/receive/receive.service";

/**
 * 收货单选择器
 *
 * 使用方式:
 * <receive-order-select v-model:value="formRef.receiveOrderId"></receive-order-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "ReceiveOrderSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    projectExist: {
      type: String,
      default: undefined,
    },
    contractExist: {
      type: String,
      default: undefined,
    },
    contractDetailExist: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    validStatus: {
      type: Array,
      value: { type: Array as PropType<string[]>, default: () => [] },
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data, run, loading } = ReceiveService.useSimpleListApi();
    let isOnMounted = ref(false);
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    onMounted(async () => {
      // console.log("onMounted");
      nextTick(() => {
        isOnMounted.value = true;
      });
      let obj = { storageStatus: "wrk,bfrk", validStatus: props.validStatus };
      if (props.projectExist) {
        obj["projectExist"] = props.projectExist;
      }
      if (props.contractExist) {
        obj["contractExist"] = props.contractExist;
      }
      if (props.contractDetailExist) {
        obj["contractDetailExist"] = props.contractDetailExist;
      }

      await run(obj);
    });
    onActivated(async () => {
      if (isOnMounted.value) {
        // console.log("onActivated");
        let obj = { storageStatus: "wrk,bfrk", validStatus: props.validStatus };
        if (props.projectExist) {
          obj["projectExist"] = props.projectExist;
        }
        if (props.contractExist) {
          obj["contractExist"] = props.contractExist;
        }
        if (props.contractDetailExist) {
          obj["contractDetailExist"] = props.contractDetailExist;
        }
        await run(obj);
      }
    });
    return {
      data,
      loading,
      onChange,
    };
  },
});
</script>
